import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import auth from './modules/auth';
import loader from './modules/loader';
import settings from './modules/settings';
import request from './modules/request';
import dashboard from './modules/dashboard';
// import user from './modules/user';
// import partner from './modules/partner';
// import summary from './modules/summary';
// import cc from './modules/cc';
import location from './modules/location';
import company from './modules/company';
import product from './modules/product';
import account from './modules/account';
import email from './modules/email';
import useradmin from './modules/useradmin';
import ticket from './modules/ticket';
import docfaq from './modules/docfaq';
import billing from './modules/billing';

export default new Vuex.Store({
  modules: {
    auth,
    loader,
    settings,
    request,
    dashboard,
    // user,
    // partner,
    // summary,
    // cc,
    location,
    company,
    product,
    account,
    email,
    useradmin,
    ticket,
    docfaq,
    billing
  }
});